import { ROUTE_NAME } from 'enums/routes'

export const VIDEO_BANNER_TYPE = {
  SIDEBAR: 'SIDEBAR',
  HOMEPAGE: 'HOMEPAGE',
  CATEGORY: 'CATEGORY',
  ARTICLE: 'ARTICLE',
  ALL_NEWS_SIDEBAR: 'ALL_NEWS_SIDEBAR',
  RSS: 'RSS'
}

export const VIDEO_BANNER_SETTINGS_BY_BANNER_TYPE = {
  [VIDEO_BANNER_TYPE.CATEGORY]: {
    playerApiId: '3',
    playerIdDesktop: '120450',
    playerIdMobile: '120450'
  },
  [VIDEO_BANNER_TYPE.ARTICLE]: {
    playerApiId: '4',
    playerIdDesktop: '120384',
    playerIdMobile: '120384'
  },
  [VIDEO_BANNER_TYPE.HOMEPAGE]: {
    playerApiId: '4',
    playerIdDesktop: '120384',
    playerIdMobile: '120384'
  },
  [VIDEO_BANNER_TYPE.RSS]: {
    playerApiId: '4',
    playerIdDesktop: '120384',
    playerIdMobile: '120384'
  }
}

export const PAGES_WITH_VIDEO_BANNER_ABOVE_FOOTER = [
  ROUTE_NAME.HOMEPAGE,
  ROUTE_NAME.CATEGORY_ARTICLE,
  ROUTE_NAME.CATEGORY_ARTICLE_GIBBERISH,
  ROUTE_NAME.CATEGORY_MIGRATED_ARTICLE_GIBBERISH,
  ROUTE_NAME.RSS
]

export const LAYOUT_VIDEO_BANNER_TYPE_BY_PAGE_NAME = {
  [ROUTE_NAME.HOMEPAGE]: VIDEO_BANNER_TYPE.HOMEPAGE,
  [ROUTE_NAME.CATEGORY_ARTICLE]: VIDEO_BANNER_TYPE.ARTICLE,
  [ROUTE_NAME.CATEGORY_ARTICLE_GIBBERISH]: VIDEO_BANNER_TYPE.ARTICLE,
  [ROUTE_NAME.CATEGORY_MIGRATED_ARTICLE_GIBBERISH]: VIDEO_BANNER_TYPE.ARTICLE,
  [ROUTE_NAME.RSS]: VIDEO_BANNER_TYPE.RSS
}
